import { useContext } from "react"
import { SessionContext } from "../../contexts/auth/SessionContext"

/**
 * Hook to access the session context. It returns the logged in user object.
 * @returns {{ user: import('../../services/auth.service.d.ts').UserData, refreshUser: () => Promise<void>, loading: boolean, routes: any[] }}
 */
export function useSession() {
  const context = useContext(SessionContext)
  if (context === undefined) {
    throw new Error("useSession must be used within a SessionProvider")
  }
  return context
}
